import {memo} from 'react'
import {DatePickerV2, TRowFilter, TextInputV2} from '../../../../../components'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {
  filterSelector,
  setFilterLogQueue as setFilter,
} from '../../../../../redux/slices/filterSlices'
import {Selection} from '../../../../../components/Selection'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterLogQueue: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilter({...filter, ...value}))
  }

  const statusOptions = [
    {label: t('processing'), value: '1'},
    {label: t('completed'), value: '2'},
    {label: t('failed'), value: '3'},
    {label: t('canceled'), value: '4'},
  ]

  return (
    <TRowFilter>
      <td>
        <div style={{margin: '2px 0'}}>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Activity')}
          value={filter?.activities ?? ''}
          onChange={({target}) => handleFilterChange({activities: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-user')}
          value={filter?.username ?? ''}
          onChange={({target}) => handleFilterChange({username: target.value})}
        />
      </td>
      <td>
        <Selection
          data={statusOptions}
          placeholder={t('TableBank.status')}
          value={filter?.status ?? ''}
          onChange={(status) => handleFilterChange({status})}
        />
      </td>

      <td>
        <TextInputV2
          placeholder={t('Message')}
          value={filter?.message ?? ''}
          onChange={({target}) => handleFilterChange({message: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('start-date')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleFilterChange({created_at: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('finish-date')}
          isSelectsRange={false}
          startDate={filter?.updated_at ?? ''}
          onChange={({startDate}) => handleFilterChange({updated_at: startDate})}
        />
      </td>
      <td>
        <div style={{margin: '2px 0'}}>&nbsp;</div>
      </td>
    </TRowFilter>
  )
})
